import { v4 } from 'uuid'

export function generateHtmlId() {
  return v4()
}

export function isA11yLinkSupported(country, locale) {
  return country?.toLowerCase() !== 'xz' && !['ko', 'zh', 'ja'].includes(locale?.toLowerCase())
}
